import Utility from './Utility';
let API = null;
let ApiConnector = {

    call: async (method, resource, params, token) => {

        if (!method || !resource) {
            return;
        }

        token = token ? token : '';

        if (!API) {
            let config = Utility.getConfig();
            let environment = config.environment;
            if (environment === "development") {
                API = "http://localhost/";
            }
            else {
                API = "https://snapcounter.app/";
            }
        }
        let uri = API + resource;

        // stick on params as querystring if there are any
        if (method.toLowerCase() === 'get' && params && Utility.isObjectAndNotEmpty(params)) {
            var queryString = Object.keys(params).map((key) => {
                return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
            }).join('&');
            if (uri.includes('?')) {
                uri += '&' + queryString
            }
            else {
                uri += '?' + queryString
            }
        }

        return new Promise((resolve, reject) => {
            if (method.toLowerCase() === 'post') {
               // console.log('fetch uri:', uri)
                try {

                    fetch(uri, {
                        method: method,
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(params)
                    }).then(response => {

                        response.json().then(data => {
                            if (data.hasOwnProperty('error')) {
                                reject(data)
                            }
                            else {
                                resolve(data)
                            }
                        })
                    },
                        error => {
                            console.warn('error: ', error)
                            reject(error)
                        })
                        .catch(error => console.warn('caught error: ', error))




                }
                catch (error) {
                    console.warn(error)
                }

            }

            if (method.toLowerCase() === 'get' && token !== '') {
                fetch(uri, {
                    method: method,
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': token,
                    },
                }).then(response => {

                    if (response.status !== 200) {
                        // try again after a short delay
                        setTimeout(() => {
                            response = fetch(uri, {
                                method: method,
                                headers: {
                                    Accept: 'application/json',
                                    'Content-Type': 'application/json',
                                    'Authorization': token,
                                },
                            }).then(response => {
                                if (response.status !== 200) {
                                    reject('api did not accept request, status: ' + response.status + ' statusText: ' + response.statusText)
                                }
                                else {
                                    response.json().then(data => resolve(data))
                                }
                            })
                        }, 100)
                    }
                    else {
                        response.json().then(data => resolve(data))
                    }
                }, error => {
                    // try again after a short delay
                    setTimeout(() => {
                        fetch(uri, {
                            method: method,
                            headers: {
                                Accept: 'application/json',
                                'Content-Type': 'application/json',
                                'Authorization': token,
                            },
                        }).then(response => {
                            if (response.status !== 200) {
                                reject('api did not accept request, status: ' + response.status + ' statusText: ' + response.statusText)
                            }
                            else {
                                response.json().then(data => resolve(data))
                            }
                        })
                    }, 100)
                }).catch(error => console.warn('caught error: ', error))
            }

            if (method.toLowerCase() === 'get' && token === '') {

                fetch(uri).then(response => {

                    if (response.status !== 200) {
                        // try again after a short delay
                        setTimeout(() => {
                            response = fetch(uri).then(response => {
                                if (response.status !== 200) {
                                    reject('api did not accept request, status: ' + response.status + ' statusText: ' + response.statusText)
                                }
                                else {
                                    response.json().then(data => resolve(data))
                                }
                            })
                        }, 100)
                    }
                    else {
                        response.json().then(data => resolve(data))
                    }
                }, error => {
                    // try again after a short delay
                    setTimeout(() => {
                        fetch(uri).then(response => {
                            if (response.status !== 200) {
                                reject('api did not accept request, status: ' + response.status + ' statusText: ' + response.statusText)
                            }
                            else {
                                response.json().then(data => resolve(data))
                            }
                        })
                    }, 100)
                }).catch(error => console.warn('caught error: ', error))

            }
        })
    }

}

export default ApiConnector;